import { createFileRoute } from '@tanstack/react-router';
import EmployeesShiftTable from '@/modules/employees/employees-shift/EmployeesShiftTable';
import { getUsersCurrent } from '@/services/users';

export const Route = createFileRoute('/(dashboard)/_dashboard/hr/employee/shift')({
  component: EmployeesShiftTable,
  loader: async () => getUsersCurrent(),
});
